var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25 50a25 25 0 010-50 25 25 0 010 50zm-3.5-11.4H27V25h4l.5-4.7H27V18c0-1.3.2-2 2-2h2.3v-4.6h-3.7c-4.5 0-6 2.3-6 6v3h-3V25h3v13.6z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social--facebook-b6bc8e79624e86016ab45dc69bee69b9.svg";
export { SvgIconSocialFacebook as Component };